<style>
@import '../../custom/css/ver-pedido-contrato.css';
</style>

<template>
  <div class="pedido-contrato">
    <div class="row m-0" v-if="contratoProfissional !== null">
      <div class="col-12">
        <h1 class="text-uppercase">
          Pedido Nº {{ contratoProfissional[0].id }}
        </h1>
        <hr class="linha-amarela" />
        <table class="info m-0 w-100">
          <tr>
            <th class="titulo">E-mail:</th>
            <td class="texto">{{ contratoProfissional[0].usuario.email }}</td>
          </tr>
          <tr v-if="contratoProfissional[0].usuario.cnpj !== ''">
            <th class="titulo">CNJP:</th>
            <td class="texto">{{ contratoProfissional[0].usuario.cnpj }}</td>
          </tr>
          <tr v-if="contratoProfissional[0].usuario.cpf !== ''">
            <th class="titulo">Cpf:</th>
            <td class="texto">{{ contratoProfissional[0].usuario.cpf }}</td>
          </tr>
          <tr>
            <th class="titulo">Data do pedido:</th>
            <td class="texto">{{ contratoProfissional[0].criado_em }}</td>
          </tr>
        </table>

        <div
          class="btn btn-add-trab"
          v-if="contratoProfissional[0].destaque !== 1"
          @click="planoBasico()"
        >
          Plano Basico
        </div>
        <div
          class="btn btn-add-trab m-l-10"
          v-if="contratoProfissional[0].destaque !== 1"
          @click="planoDestaque()"
        >
          Plano Destaque
        </div>
        <div class="btn btn-add-trab m-l-10" @click="voltar()">Voltar</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'pedido-contrato',
  props: ['id'],
  created() {
    this.$store.dispatch('showContratoProfissional', this.id);
  },
  computed: {
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      contratoProfissional: (state) => state.contratoProfissional,
    }),
  },
  methods: {
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    planoBasico() {
      if (
        confirm(
          'Você realmente deseja mudar o profissional para o plano basico?'
        )
      ) {
        this.$store
          .dispatch('updateContratoProfissionalBasico', this.id)
          .then(() => {
            this.$store.dispatch('startLoader');
            setTimeout(() => {
              this.$store.dispatch('endLoader');
              this.aviso(
                'O plano do profissional foi alterado com sucesso!',
                'success'
              );
              setTimeout(() => {
                this.$router.push({
                  name: 'administrador-ver-pedidos-contratos',
                });
              }, 1000);
            }, 1500);
          })
          .catch(() => {
            this.aviso(
              'Houve um problema, tente novamente em 5 minutos!',
              'danger'
            );
          });
      }
    },
    planoDestaque() {
      if (
        confirm(
          'Você realmente deseja mudar o profissional para o plano destaque?'
        )
      ) {
        this.$store
          .dispatch('updateContratoProfissionalDestaque', this.id)
          .then(() => {
            this.$store.dispatch('startLoader');
            setTimeout(() => {
              this.$store.dispatch('endLoader');
              this.aviso(
                'O plano do profissional foi alterado com sucesso!',
                'success'
              );
              setTimeout(() => {
                this.$router.push({
                  name: 'administrador-ver-pedidos-contratos',
                });
              }, 1000);
            }, 1500);
          })
          .catch(() => {
            this.aviso(
              'Houve um problema, tente novamente em 5 minutos!',
              'danger'
            );
          });
      }
    },
    voltar() {
      this.$router.push({
        name: 'administrador-ver-pedidos-contratos',
      });
    },
  },
};
</script>
